/** Neutral service keeps the base fare; good experiences can earn up to ten percent more. */
export function ticketHappinessBonus(happiness = 80): number {
    return 1 + Math.max(0, Math.min(20, happiness - 80)) / 200;
}

/** Serial residues keep shopping choices deterministic across multiplayer peers. */
export function buysSnack(serial: number, happiness: number): boolean {
    const chance = happiness < 40 ? 3 : happiness < 70 ? 8 : 17;
    return serial % 6 === 0 && Math.floor(serial / 6) % 17 < chance;
}
